import queries from '@apis/queries';
import { useQuery } from '@tanstack/react-query';

function useTermCategoryHistory() {
  const { data } = useQuery(queries.termCategories.history());
  return data?.categories;
}

export default useTermCategoryHistory;
